import React from 'react';

import { Collapse } from 'antd';
import { Box, Button, Container, Grid, Stack, Typography, styled } from '@mui/material';
import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp';
import MuiAccordion from '@mui/material/Accordion';
import MuiAccordionSummary from '@mui/material/AccordionSummary';
import MuiAccordionDetails from '@mui/material/AccordionDetails';
import Iconify from '../Iconify';
import CustomButton from '../CustomButton';
import LucideIcon from '../LucideIcon';
import CustomTypo from '../ui/customTypo';


const { Panel } = Collapse;

const Accordion = styled((props) => <MuiAccordion disableGutters elevation={2} square {...props} />)(({ theme }) => ({
    border: '1px solid #f2f2f2',
    borderRadius: '10px',
    marginBottom: 20,
    padding: 10,
    '&:not(:last-child)': {
        borderBottom: 1,
    },
    '&::before': {
        display: 'none',
    },
}));

const AccordionSummary = styled((props) => (
    <MuiAccordionSummary expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: '0.9rem' }} />} {...props} />
))(({ theme }) => ({
    backgroundColor: 'transparent',
    flexDirection: 'row-reverse',
    '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
        transform: 'rotate(90deg)',
    },
    '& .MuiAccordionSummary-content': {
        marginLeft: theme.spacing(1),
    },
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
    padding: theme.spacing(2),
    borderTop: '1px solid rgba(0, 0, 0, .125)',
}));

function CTASection() {
    const [expanded, setExpanded] = React.useState('panel1');

    const handleChange = (panel) => (event, newExpanded) => {
        setExpanded(newExpanded ? panel : false);
    };

    return (
        <div className="block ">
            <div className="">
                <div>
                    <Stack paddingX={{ xs: 5, sm: 10, md: 20, lg: 30, xl: 40 }}>

                        <Typography textAlign="center" variant="h2" >
                            Prêt à <span style={{ color: '#5E17EB' }}>vous lancer ?</span>
                        </Typography>
                        <CustomTypo type='content' color='text.secondary' textAlign='center'>
                            Rejoignez des milliers d'organisateurs qui font confiance à Choptonticket pour leurs événements. Créez votre premier événement en quelques minutes.
                        </CustomTypo>
                        <Typography textAlign="center" color="text.secondary" fontSize={20}>
                            Rejoignez des milliers d'organisateurs qui font confiance à Choptonticket pour leurs événements. Créez votre premier événement en quelques minutes.
                        </Typography>
                    </Stack>

                </div>
                <Container sx={{ paddingBottom: 8 }}>
                    <Stack spacing={4} direction="column" padding={2} alignItems="center" justifyContent="center">
                        <CustomButton type={'primaire'} buttonText={'Rejoingez choptonticket'} href="/bo/new_event" />
                        <Stack spacing={6} justifyContent={'center'} alignItems={'center'} sx={{
                            padding: { xs: 4, sm: 10 },
                            backdropFilter: "blur(12px)", // flou plus marqué
                            WebkitBackdropFilter: "blur(12px)", // Safari support
                            background: "rgba(255, 255, 255, 0.15)", // fond translucide
                            border: "1px solid rgba(255, 255, 255, 0.3)", // léger contour
                            boxShadow: "0 4px 30px rgba(0,0,0,0.1)", // ombre douce
                            borderRadius: "16px",
                            transition: "all 0.3s ease",
                            "&:hover": {
                                // background: "rgba(255, 255, 255, 0.25)", // un peu plus opaque au hover
                                // transform: "scale(1.02)", // effet subtil au survol
                            },
                        }}>
                            <Box sx={{ borderRadius: '10px', bgcolor: '#5e17eb0e' }} padding={1.5}>
                                <LucideIcon name='Headset' strokeWidth={'2'} size={70} color={'#5E17EB'} />
                            </Box>

                            <Stack spacing={2} alignItems="center" justifyContent="center">
                                <Typography textAlign="start" fontWeight={'bold'} fontSize={25} color={'text.primary'}>
                                    Vous avez une autre question ?
                                </Typography>
                                <Typography textAlign="start" fontSize={18} color={'text.secondary'}>
                                    Basée en Côte d'Ivoire, notre équipe est disponible 7j/7 pour répondre à toutes vos questions.
                                </Typography>
                                <CustomButton type={'secondaire'} buttonText={'Nous contacter'} href="/bo/new_event" />
                            </Stack>

                        </Stack>

                    </Stack>
                </Container>
            </div>
        </div>
    );
}

export default CTASection;
